module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Temperature-full-01ecab15fe7e20140b2d31504d1073a5.svg";